import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'

import { OVERLAY } from 'components/AuthModal/styles'
import CloseIcon from 'components/CloseIcon'
import { default as DefaultModal } from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import PrimaryButton from 'components/PrimaryButton'

const AddFeedbackModal = ({ show, onClose, onSave, isLoading }) => {
  const [notes, setNotes] = useState('')

  const handleChange = useCallback(e => {
    setNotes(e.target.value)
  }, [])

  const handleSave = useCallback(() => {
    if (notes.trim()) {
      onSave({ notes: notes.trim() })
    }
  }, [notes, onSave])

  const isDisabled = !notes.trim() || isLoading

  return (
    <Overlay
      show={show}
      className={OVERLAY}
      preventEscBackdropClose={true}
      onClose={() => onClose()}
    >
      <DefaultModal innerClassName="overflow-y-scroll flex flex-col justify-center px-5">
        <div className="relative h-auto flex flex-col items-center text-white w-full rounded-xl px-5 py-6 bg-woodsmokeBlackDarker md:w-96">
          <div className="w-full flex justify-end">
            <button
              className="bg-white bg-opacity-20 w-5 h-5 mb-2 rounded-full flex items-center justify-center"
              onClick={() => onClose()}
            >
              <CloseIcon className="w-2 h-2 text-white" />
            </button>
          </div>
          <div className="text-lg mb-8">Add Feedback</div>
          <div className="w-full mb-6">
            <label className="block text-sm mb-2">Notes</label>
            <textarea
              value={notes}
              onChange={handleChange}
              rows={6}
              placeholder="Enter feedback notes..."
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <PrimaryButton className="bg-azure w-full" disabled={isDisabled} onClick={handleSave}>
            {isLoading ? 'Saving...' : 'Save Feedback'}
          </PrimaryButton>
        </div>
      </DefaultModal>
    </Overlay>
  )
}

AddFeedbackModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
}

export default AddFeedbackModal
